import React from 'react';
import { connect } from 'react-redux';
import { hashHistory } from 'react-router';
import { Helmet } from 'react-helmet';
import { toast } from 'react-toastify';
import { BigBreadcrumbs, WidgetGrid, JarvisWidget } from '../../../components';
import PatientForm from '../components/PatientForm';
import { hostTitle } from '../../../config/ui';
import { requestPatient, createPatient, updatePatient } from '../../../store/patients/PatientsActions';
import { requestGenders } from '../../../store/cir-manager/ClinicalIncidentActions';
import { requestStates } from '../../../store/referral-directory/ReferralDirectoryActions';
import { requestPhoneTypes } from '../../../store/service-request-manager/ServiceRequestManagerActions';
import { requestEmployersTypeahead } from '../../../store/advocate-dashboard/AdvocateActions';
import { requestClientsTypeahead } from '../../../store/client-manager/ClientManagerActions';

class PatientEdit extends React.Component {
 
  componentWillMount() {
    this.props.getPatient(this.props.params.masterPatientId, {
      tenantId: this.props.tenantId,
    });
    this.props.getStates({
      tenantId: this.props.tenantId,
    });
  }
  
  searchPhoneTypes = () => {
    return this.props
      .getPhoneTypes({
        tenantId: this.props.tenantId
      })
      .then((result) => {
        const options = [];
        if (result.payload.data) {
          result.payload.data.forEach((item) =>
            options.push({ id: item.id, name: item.name }),
          );
        }
        return options;
      });
  };

  searchStates = () => {
    return this.props
      .getStates({
        tenantId: this.props.tenantId
      })
      .then((result) => {
        const options = [];
        if (result.payload.data) {
          result.payload.data.forEach((item) =>
            options.push({ id: item.id, name: item.name }),
          );
        }
        return options;
      });
  };

  searchGenders = () => {
    return this.props
      .getGenders({
        tenantId: this.props.user.queryParams.tenantId,
      })
      .then((result) => {
        const options = [];
        if (result.payload.data) {
          result.payload.data.forEach((item) =>
            options.push({ id: item.id, name: item.name }),
          );
        }
        return options;
      });
  };

  searchEmployers = (search) => {
    return this.props
      .employersTypeahead({
        tenantId: this.props.tenantId,
        search,
      })
      .then((result) => {
        const options = [];
        if (result.payload.data) {
          result.payload.data.forEach((item) =>
            options.push({ code: item.code, name: item.name }),
          );
        }
        return options;
      });
  };

  searchClients = (search) => {
    return this.props
      .clientsTypeahead({
        tenantId: this.props.tenantId,
        search,
      })
      .then((result) => {
        const options = [];
        if (result.payload.data) {
          result.payload.data.forEach((item) =>
            options.push({ employerCodeNumber: item.code, employerCodeDescription: item.name }),
          );
        }
        return options;
      });
  };

  onSubmit = (values) => {
    //values.stateId = values.state.id;
    //values.addressState = values.state.name;
    values.fullName = values.firstName + ' ' + values.lastName;
    values.employerCodeNumber = (values.client !== undefined) ? values.client.employerCodeNumber : null;
    values.employerName = (values.client !== undefined) ? values.client.employerCodeDescription : null;
    values.gender = values.genderObj.name.substring(0, 1);
    if (values.masterPatientId === 0) {
      this.props
        .createPatient(values, {
          tenantId: this.props.user.queryParams.tenantId,
        })
        .then((result) => {
          if (result.error) {
            toast.error('Something went wrong. Try again later.');
          }
          else {
            toast.success('Patient has been created.');
            hashHistory.push(`/patients/`);
          }
        });
    }
    else {
      this.props
        .updatePatient(values, this.props.params.masterPatientId, {
          tenantId: this.props.user.queryParams.tenantId,
        })
        .then((result) => {
          if (result.error) {
            toast.error('Something went wrong. Try again later.');
          }
          else {
            toast.success('Patient has been updated.');
            hashHistory.push(`/patients/`);
          }
        });
    }
  };

  onCancel = () => {
    hashHistory.push('/patients/');
  };

  render() {
    const {
      data: { patient,
        isLoading,
      },
      states
    } = this.props;

    const patient1 = patient.length>0 && patient[0];
    
    return (
      <div id="content">
          {patient1.masterPatientId && <Helmet title={`${patient1.masterPatientId} – ${hostTitle()}`} />}
        <BigBreadcrumbs
          items={[
            'Practice Management',
            { title: 'Patients', route: '/patients' },
            'Patient Edit',
          ]}
          icon="fa fa-fw fa-hospital-o"
          className=""
        />

        <WidgetGrid>
          <JarvisWidget
            color="white"
            fullscreenbutton={true}
            colorbutton={false}
            closeButton={true}
            editbutton={false}
            togglebutton={false}
            deletebutton={false}
          >
            <header>
              <span className="widget-icon">
                {' '}
                <i className="fa fa-table" />{' '}
              </span>
              <h2>
                {`Add/Edit Patient`}
              </h2>
            </header>
            <div>
              <div className="row">
                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
                  <div className="row">
                    <div className="col-md-9">
                      {/*<span> Patient Id: {patient.masterPatientId} </span>*/}
                    </div>
                    <div className="col-md-3">
                      <button
                        className="btn btn-primary pull-right"
                        onClick={this.onCancel}
                      >
                        Back
                      </button>
                    </div>
                  </div>
                  {(patient1.masterPatientId>=0) && (
                    <PatientForm
                      isLoading={isLoading}
                      searchPhoneTypes={this.searchPhoneTypes}
                      searchEmployers={this.searchEmployers}
                      searchClients={this.searchClients}
                      //searchStates={this.searchStates}
                      states={states}
                      searchGenders={this.searchGenders}
                      onSubmit={this.onSubmit}
                      onCancel={this.onCancel}
                    />
                  )}
                </div>

              </div>
            </div>
          </JarvisWidget>
        </WidgetGrid>
      </div>
    );
  }
}
export default connect(
  (state) => ({
    user: state.currentUser,
    data: state.patients,
    states: state.referraldirectory.states,
    tenantId: state.currentUser.queryParams.tenantId,
  }),
  (dispatch) => ({
    getPatient: (masterPatientId, params) =>
      dispatch(requestPatient(masterPatientId, params)),
    getStates: (params) => dispatch(requestStates(params)),
    getPhoneTypes: (params) => dispatch(requestPhoneTypes(params)),
    getGenders: (params) => dispatch(requestGenders(params)),
    employersTypeahead: (params) => dispatch(requestEmployersTypeahead(params)),
    clientsTypeahead: (params) => dispatch(requestClientsTypeahead(params)),
    createPatient: (patient, params) => dispatch(createPatient(patient, params)),
    updatePatient: (patient, patientId, params) => dispatch(updatePatient(patient, patientId, params))
  }),
)(PatientEdit);



// WEBPACK FOOTER //
// ./src/routes/management/containers/PatientEdit.js